import React, { useEffect, useState } from "react";
import StepSatu from "../FormTransaksi/StepSatu";
import StepDua from "../FormTransaksi/StepDua";
import StepTiga from "../FormTransaksi/StepTiga";
import useAxios from "../../../Utils/useAxios";
import {
  formatRP,
  getDateToday,
  getUser,
} from "../../../Utils/externalFunctions";
import { convertRPInputToIntValue } from "../../../Utils/otherFunctions";
import { timeToast } from "../../../Constant";
import { toast } from "react-toastify";
import { FORM_TYPE } from "../../../Constant/FormType";
import { getInputDateBeforeTodayError } from "../../../Constant/Message";
import FormStepContainer from "../../../Layout/Containers/FormStepContainer";
import {
  getAnggaranBUK,
  getJenisPembayaran,
  getRencImpNotZero,
  getUMO,
  getUMOTransaksi,
  getUnitKerja,
} from "../services";
import generateUniqueId from "../utils/generateUniqueId";
toast.configure();

const BuatTransaksi = () => {
  const axiosInstance = useAxios();

  const [unitKerja, setUnitKerja] = useState([]);
  const [anggaranBUK, setAnggaranBUK] = useState([]);
  const [jenisPembayaran, setJenisPembayaran] = useState([]);
  const [step, setStep] = useState(0);
  const [umoList, setUMOList] = useState([]);
  const [anggaranRencimpTransaksi, setAnggaranRencimpTransaksi] = useState([]);
  const [total, setTotal] = useState(0);
  const [formattedNilai, setFormattedNilai] = useState("0");
  const [anggaranRencimpFormattedNilai, setAnggaranRencimpFormattedNilai] =
    useState([]);
  const [rencImp, setRencImp] = useState([]);
  const [formTransaksi, setFormTransaksi] = useState({
    id_transaksi: "",
    id_unit_kerja: "",
    tanggal_transaksi: "",
    nilai_transaksi: "",
    keterangan: "",
    diajukan_oleh: getUser(),
    tanggal_diajukan: getDateToday("original"),
    disetujui_oleh: "",
    dibayar_oleh: "",
    dibayarkan_ke: "",
    id_um_list: [],
    id_counterpart: "",
    kode_jenis_pembayaran: "",
  });

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      const { data: umoData } = await getUMOTransaksi(axiosInstance);
      setUMOList(umoData);

      const { data: unitKerjaData } = await getUnitKerja(axiosInstance);
      setUnitKerja(unitKerjaData);
      if (unitKerjaData.length === 1) {
        setFormTransaksi((prev) => ({
          ...prev,
          id_unit_kerja:
            unitKerjaData.length === 1 ? unitKerjaData[0].nama_unit_kerja : "",
        }));
      }

      const { data: jenisPembayaranData } = await getJenisPembayaran(
        axiosInstance
      );
      setJenisPembayaran(jenisPembayaranData);

      const { data: rencImpData } = await getRencImpNotZero(axiosInstance);
      setRencImp(rencImpData);

      const { data: anggaranbUKData } = await getAnggaranBUK(axiosInstance);
      setAnggaranBUK(anggaranbUKData);

      setFormTransaksi((prev) => ({
        ...prev,
        id_transaksi: generateUniqueId(),
      }));
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [anggaranRencimpTransaksi]);

  useEffect(() => {
    setAnggaranRencimpFormattedNilai(() => {
      return rencImp.map((item) => {
        return {
          pk: item.pk,
          formatted_nilai: "0",
          isValid: true,
        };
      });
    });
  }, [rencImp]);

  const calculateTotal = () => {
    let sum = 0;
    anggaranRencimpTransaksi.forEach((item) => {
      const value = parseFloat(item.anggaran_digunakan);
      if (!isNaN(value)) {
        sum += value;
      }
    });
    setTotal(sum);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "tanggal_transaksi") {
      const selectedDate = new Date(value);
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      if (selectedDate < yesterday) {
        {
          toast.error(getInputDateBeforeTodayError(), {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: timeToast,
          });
        }
        return;
      }
      setFormTransaksi((prevState) => ({
        ...prevState,
        tanggal_transaksi: value,
      }));
    } else if (name === "nilai_transaksi") {
      const numericValue = convertRPInputToIntValue(value);
      setFormTransaksi((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      setFormattedNilai(formatRP(numericValue));
    } else {
      setFormTransaksi((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleCheckbox = (e) => {
    const { id, checked } = e.target;
    if (checked) {
      setFormTransaksi((prevForm) => ({
        ...prevForm,
        id_um_list: [...prevForm.id_um_list, id],
      }));
    } else {
      setFormTransaksi((prevForm) => ({
        ...prevForm,
        id_um_list: prevForm.id_um_list.filter((item) => item !== id),
      }));
    }
  };

  const handleCheckboxUMO = (list) => {
    if (list === null) {
      return;
    }
    setFormTransaksi((prevState) => ({
      ...prevState,
      id_um_list: list.map((item) => item.value),
    }));
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const fieldType = e.target.getAttribute("data-field-type");

    const numericValue = convertRPInputToIntValue(value);

    setAnggaranRencimpFormattedNilai((prev) => {
      return prev.map((item) => {
        if (item.pk === parseInt(id)) {
          return { ...item, formatted_nilai: formatRP(numericValue) };
        } else {
          return item;
        }
      });
    });

    if (numericValue === 0) {
      setAnggaranRencimpTransaksi((prev) =>
        prev.filter((item) => item.rencana_imp !== id)
      );
    } else {
      setAnggaranRencimpTransaksi((prev) => {
        const existingObject = prev.find((item) => item.rencana_imp === id);
        if (existingObject) {
          return prev.map((item) =>
            item.rencana_imp === id
              ? { ...item, [fieldType]: numericValue }
              : item
          );
        } else {
          const newObject = {
            id_anggaran_dipakai_transaksi: formTransaksi.id_transaksi,
            rencana_imp: id,
            [fieldType]: numericValue,
          };
          return [...prev, newObject];
        }
      });
    }
  };

  const handleFileChange = (e) => {
    const doc = e.target.files[0];
    setFormTransaksi((prev) => ({
      ...prev,
      doc: doc,
    }));
  };

  const nextStep = (e) => {
    setStep(step + 1);
  };

  const prevStep = (e) => {
    setStep(step - 1);
  };

  return (
    <FormStepContainer step={step}>
      <StepSatu
        nextStep={nextStep}
        prevStep={prevStep}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleCheckbox={handleCheckbox}
        handleCheckboxUMO={handleCheckboxUMO}
        umoList={umoList}
        formTransaksi={formTransaksi}
        unitKerja={unitKerja}
        jenisPembayaran={jenisPembayaran}
        formattedNilai={formattedNilai}
        formType={FORM_TYPE.Create}
      />
      <StepDua
        nextStep={nextStep}
        prevStep={prevStep}
        handleInputChange={handleInputChange}
        total={total}
        rencImp={rencImp}
        anggaranBUK={anggaranBUK}
        anggaranRencimpTransaksi={anggaranRencimpTransaksi}
        formTransaksi={formTransaksi}
        unitKerja={unitKerja}
        jenisPembayaran={jenisPembayaran}
        anggaranRencimpFormattedNilai={anggaranRencimpFormattedNilai}
        setAnggaranRencimpFormattedNilai={setAnggaranRencimpFormattedNilai}
        formType={FORM_TYPE.Create}
      />
      <StepTiga
        prevStep={prevStep}
        total={total}
        formTransaksi={formTransaksi}
        rencImp={rencImp}
        anggaranRencimpTransaksi={anggaranRencimpTransaksi}
        formType={FORM_TYPE.Create}
      />
    </FormStepContainer>
  );
};

export default BuatTransaksi;
